import React from "react";
import HeaderV2 from "./HeaderV2";
import FooterV2 from "./FooterV2";
import V2PageHero from "./sections/V2PageHero";
import WhoWeAreV2 from "./sections/WhoWeAreV2";
import JourneyV2 from "./sections/JourneyV2";
import AgenciesV2 from "./sections/AgenciesV2";
import CTAV2 from "./sections/CTAV2";
import InlineCTA from "./sections/InlineCTA";
import useSmoothScroll from "../../hooks/useSmoothScroll";
import { motion } from "framer-motion";
import { Compass, Map, Target, Sparkles } from "lucide-react";

const VALUES = [
  {
    icon: Compass,
    t: "Mission",
    d: "Make UAE business setup the simplest, most transparent decision for global founders.",
  },
  {
    icon: Map,
    t: "Vision",
    d: "Be the trusted launchpad for every entrepreneur who chooses the UAE as their home base.",
  },
  {
    icon: Target,
    t: "Approach",
    d: "Senior advisors, written quotes, weekly status reports, SLA-backed turnarounds. No exceptions.",
  },
  {
    icon: Sparkles,
    t: "Promise",
    d: "What you're quoted is what you pay. What we promise is what we deliver. In writing.",
  },
];

export default function AboutV2() {
  useSmoothScroll(true);
  return (
    <div data-testid="v2-about-page" className="bg-white">
      <HeaderV2 />
      <main>
        <V2PageHero
          eyebrow="About StartINC"
          title="A new generation of"
          highlight="UAE corporate services."
          copy="Built by operators who have sat on every side of the table — government desks, banking compliance, and the founder's chair."
          image="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=2400&q=80"
        />

        <WhoWeAreV2 />

        {/* Mission/Vision/Approach */}
        <section className="bg-[#F8FAFC] py-10 md:py-14">
          <div className="container-x">
            <div className="max-w-2xl mb-7">
              <p className="overline text-[#3366FF]">What we stand for</p>
              <div className="gold-rule mt-5 mb-6" />
              <h2 className="font-heading font-light tracking-tight text-[#0F172A] text-2xl sm:text-3xl lg:text-[2.5rem] leading-tight">
                Four principles —{" "}
                <span className="font-black text-[#002366]">non-negotiable</span>.
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {VALUES.map(({ icon: Icon, t, d }, i) => (
                <motion.div
                  key={t}
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.07 }}
                  className="p-7 rounded-sm border border-slate-200 bg-white hover:shadow-md hover:border-[#3366FF]/40 transition-all"
                >
                  <div className="w-11 h-11 rounded-sm bg-[#EEF2FF] text-[#3366FF] inline-flex items-center justify-center">
                    <Icon className="w-5 h-5" strokeWidth={1.5} />
                  </div>
                  <div className="mt-5 font-heading font-semibold text-[#0F172A] text-lg">
                    {t}
                  </div>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{d}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        <JourneyV2 />

        <InlineCTA
          eyebrow="Let's start the conversation"
          title="Reach a senior advisor in one click — no gatekeepers."
          buttonLabel="Get In Touch"
        />

        <AgenciesV2 />
        <CTAV2 />
      </main>
      <FooterV2 />
    </div>
  );
}
